<template>
  <v-container class="my-0 py-1" fluid>
    <v-row>
      <v-col class="col-3">
        <v-text-field
          placeholder="Buscar medidores..."
          v-model="search"
          append-icon="search"
          single-line
        ></v-text-field>
      </v-col>
      <v-col class="text-right">
        <v-btn color="primary" @click="selected = {}; createUpdate = true">Crear nuevo medidor</v-btn>
      </v-col>
    </v-row>
    <v-data-table :headers="headers" :items="meters" :items-per-page="5" :search="search">
      <template
        v-slot:item.carga="{ item }"
      >{{ item.carga ? item.carga.toUpperCase() : '[SIN CARGA ASIGNADA]' }}</template>

      <template v-slot:item.downloadable="{ item }">
        <v-switch v-model="item.downloadable" @change="convertToNimbeo(item)"></v-switch>
      </template>

      <template v-slot:item.acciones="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              text
              color="primary"
              v-on="on"
              @click="selected = item; createUpdate = true"
            >
              <i class="fa fa-pencil"></i>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
        <v-tooltip bottom v-if="false">
          <template v-slot:activator="{ on }">
            <v-btn
              small
              text
              color="warning"
              v-on="on"
              @click="selected = item; transferirDlg = true; getDisponibles()"
            >
              <i class="fa fa-mail-forward"></i>
            </v-btn>
          </template>
          <span>Transferir</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn small text color="error" v-on="on" @click="deleteMeter(item)">
              <i class="fa fa-trash"></i>
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog v-model="transferirDlg" width="300" persistent>
      <v-card>
        <v-card-title>Transferir medidor</v-card-title>
        <form @submit.prevent>
          <v-card-text>
            <!-- <v-select label="Medidor"></v-select> -->
            <v-select
              :items="disponibles"
              item-text="name"
              item-value="id"
              v-model="transferencia.destino"
              label="Carga destino"
              hide-details
            ></v-select>
            <v-checkbox v-model="transferencia.desinstalar" label="Desinstalar carga origen"></v-checkbox>
            <v-chip>{{ selected.concentrator_id }}</v-chip>&nbsp;
            <i class="fa fa-arrow-right"></i>&nbsp;
            <v-chip>AEROPUERTO</v-chip>
          </v-card-text>
          <v-card-actions>
            <v-btn color="success" text type="submit">Tranferir</v-btn>
            <v-btn color="error" text @click="transferirDlg = false">Cancelar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="createUpdate" width="500" persistent>
      <v-card>
        <v-card-title>{{ selected.id ? 'Editar' : 'Crear' }} medidor</v-card-title>
        <form @submit.prevent="createOrUpdate">
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="selected.concentrator_id"
                  label="Concentrator Id"
                  outlined
                  required
                  :disabled="selected.id"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field v-model="selected.referencia" label="Referencia" outlined required></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field v-model="selected.serial" label="Serial" outlined required></v-text-field>
              </v-col>
              <v-col>
                <v-text-field v-model="selected.simcard" label="# SIM" outlined required></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-switch label="NIMBEO" v-model="selected.downloadable"></v-switch>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="success" small type="submit">Guardar {{ selected.id ? 'Cambios' : '' }}</v-btn>
            <v-btn color="error" small @click="createUpdate = false">Cancelar</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from "vue";
import { API } from "../../../globals";
import { Auth } from "../../../classes/Auth";
import { apiv1 } from "../../../libs/apiv1";

const auth = new Auth();

export default Vue.extend({
  name: "Medidor",
  data: () => ({
    headers: [
      { text: "Carga", value: "carga" },
      { text: "Concentrator", value: "concentrator_id" },
      { text: "Referencia", value: "referencia" },
      { text: "Serial", value: "serial" },
      { text: "# SIM", value: "simcard" },
      { text: "NIMBEO", value: "downloadable" },
      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        width: 200
      }
    ],
    meters: [],
    disponibles: [],
    cargas: [],
    search: null,
    createUpdate: false,
    transferirDlg: false,
    selected: {},
    transferencia: {},
    user: auth.getUser(),
    auth: auth
  }),
  mounted() {
    this.getMeters();
    this.getCargas();
  },
  methods: {
    getMeters: function() {
      apiv1({
        method: "GET",
        url: `meters?project=${auth.getProject().id}`
      }).then(res => {
        this.meters = res.data;
      });
    },
    getCargas: function() {
      apiv1({
        method: "GET",
        url: `cargas?project=${this.user.id}&desinstaladas=true`
      }).then(res => (this.cargas = res.data));
    },
    createOrUpdate: function() {
      let url = `meters`;
      let method = "POST";
      if (this.selected.id) {
        url += "/" + this.selected.id;
        method = "PUT";
      }
      apiv1({
        method: method,
        url: url,
        data: this.selected
      })
        .then(res => {
          this.getMeters();
          this.createUpdate = false;
          this.selected = {};
          this.$awn.success(res.data);
        })
        .catch(err => {
          this.$awn.alert(err.response.data);
        });
    },
    tranferir: function() {},
    getDisponibles: function() {
      apiv1({
        method: "GET",
        url: `cargas?project=${auth.getProject().id}&disponibles=true`
      }).then(res => (this.disponibles = res.data));
    },
    deleteMeter: function(item) {
      this.$swal({
        title: "Continuar?",
        text: `¿Seguro que desea eliminar el medidor '${item.concentrator_id.toUpperCase()}'?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, deseo eliminarlo",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value) {
          apiv1({
            method: "DELETE",
            url: `meter/${item.id}`
          }).then(res => {
            this.getMeters();
            this.$awn.success(res.data);
          });
        }
      });
    },
    convertToNimbeo: function(item) {
      apiv1({
        method: "PUT",
        url: `change-nimbeo/${item.id}`,
        data: {
          state: !!item.downloadable
        }
      })
        .then(res => {
          this.$awn.success(res.data);
          this.getMeters();
        })
        .catch(err => {
          this.getMeters();
        });
    }
  }
});
</script>

<style lang="sass">

</style>